import type { FC } from 'react';
import React from 'react';
import { useStore } from 'zustand';

import { ModalListErrors } from 'Features/SellerCommunications/components/ModalListErrors';
import { ProcessingEmailsStore } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

export const ProcessingEmailsError: FC = () => {
	const { errorGroups, result } = useStore(ProcessingEmailsStore);

	const updatedSaleIdsCount = result.updatedSaleIds.length;
	const failedToUpdateSalesCount = result.failedToUpdateSales.length;

	const errorsText = T.translate(
		`processingEmailsError.description.${failedToUpdateSalesCount === 1 ? 'error_singular' : 'error_plural'}`,
		{ errorsCount: failedToUpdateSalesCount },
	);
	const successText = T.translate(
		`processingEmailsError.description.${updatedSaleIdsCount === 1 ? 'success_singular' : 'success_plural'}`,
		{ successCount: updatedSaleIdsCount },
	);

	return (
		<ModalListErrors
			groups={errorGroups}
			headerDescription={`${successText}${errorsText}`}
			headerTitle={T.translate('processingEmailsError.title')}
			infoBoxDescription={T.translate('processingEmailsError.infoBox.description')}
			infoBoxTitle={T.translate(
				`processingEmailsError.infoBox.title.${failedToUpdateSalesCount === 1 ? 'single' : 'multiple'}`,
				{
					count: failedToUpdateSalesCount,
				},
			)}
		/>
	);
};
